// src/utils/filterMenu.ts
// This version checks child-level rights based on the parent right object:
// export const filterMenu = (menu: any, rights: any[]) => {
//     const filtered: any = {};

//     // Get the global right (access_all)
//     const accessAll = rights.find(
//         (r) => r.name === 'access_all'
//     );

//     // Extract global flags
//     const hasGlobalRead = accessAll?.read === true;
//     const hasGlobalAdd = accessAll?.add === true;
//     const hasGlobalEdit = accessAll?.edit === true;
//     const hasGlobalDelete = accessAll?.delete === true;

//     Object.keys(menu).forEach((key) => {
//         const item = menu[key];

//         if (item.hide) return;

//         const parentRight = rights?.find((r) => r.name === item.id);

//         // ---- If no submenu ----
//         if (!item.subMenu) {
//             if (hasGlobalRead || parentRight?.read) {
//                 filtered[key] = item;
//             }
//             return;
//         }

//         // If submenu exists → filter children based on parentRight
//         const children: any = {};

//         Object.keys(item.subMenu).forEach((childKey) => {
//             const child = item.subMenu[childKey];

//             if (child.hide) return;

//             // Global overrides first
//             if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
//                 children[childKey] = child;
//                 return;
//             }

//             // Otherwise use module-specific rights
//             if (child.id.includes('create') && parentRight?.add) children[childKey] = child;
//             else if (child.id.includes('edit') && parentRight?.edit) children[childKey] = child;
//             else if (child.id.includes('detail') && parentRight?.read) children[childKey] = child;
//             else if (parentRight?.read) children[childKey] = child; // fallback for common read items
//         });

//         if (Object.keys(children).length > 0) {
//             filtered[key] = { ...item, subMenu: children };
//         }
//     });

//     return filtered;
// };

// src/utils/filterMenu.ts

// export const filterMenu = (menu: any, rights: any[]) => {
//     const filtered: any = {};

//     // ✅ Global right check
//     const accessAll = rights.find(
//         (r) => r.name === 'access_all'
//     );

//     const hasGlobalRead = accessAll?.read === true;
//     const hasGlobalAdd = accessAll?.add === true;
//     const hasGlobalEdit = accessAll?.edit === true;
//     const hasGlobalDelete = accessAll?.delete === true;

//     Object.keys(menu).forEach((key) => {
//         const item = menu[key];
//         if (item.hide) return;

//         const parentRight = rights.find((r) => r.name === item.id);

//         // ---- If no submenu ----
//         if (!item.subMenu) {
//             if (hasGlobalRead || parentRight?.read) filtered[key] = item;
//             return;
//         }

//         // ---- If submenu exists ----
//         const children: any = {};

//         // ✅ If global rights active → show all
//         if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
//             Object.keys(item.subMenu).forEach((childKey) => {
//                 const child = item.subMenu[childKey];
//                 if (!child.hide) children[childKey] = child;
//             });
//             filtered[key] = { ...item, subMenu: children };
//             return;
//         }

//         // ✅ If only read = true → show only parent, hide dropdown
//         if (parentRight?.read && !parentRight?.add && !parentRight?.edit && !parentRight?.delete) {
//             filtered[key] = { ...item, subMenu: undefined }; // no dropdown
//             return;
//         }

//         // ✅ Otherwise filter children based on rights
//         Object.keys(item.subMenu).forEach((childKey) => {
//             const child = item.subMenu[childKey];
//             if (child.hide) return;

//             if (child.id.includes('create') && parentRight?.add) children[childKey] = child;
//             else if (child.id.includes('edit') && parentRight?.edit) children[childKey] = child;
//             else if (child.id.includes('detail') && parentRight?.read) children[childKey] = child;
//             else if (parentRight?.read) children[childKey] = child; // fallback for normal read
//         });

//         if (Object.keys(children).length > 0) {
//             filtered[key] = { ...item, subMenu: children };
//         }
//     });

//     return filtered;
// };

// Working with multi-level dropdown

// export const filterMenu = (menu: any, rights: any[], userRole: string) => {
//     const filtered: any = {};

//     // -----------------------------
//     // ✅ GLOBAL RIGHTS (access_all)
//     // -----------------------------
//     const accessAll = rights.find((r) => r.name === "access_all");

//     const hasGlobalRead = accessAll?.read === true;
//     const hasGlobalAdd = accessAll?.add === true;
//     const hasGlobalEdit = accessAll?.edit === true;
//     const hasGlobalDelete = accessAll?.delete === true;

//     const getRight = (id: string) => rights.find((r) => r.name === id);

//     const filterSubMenu = (subMenu: any) => {
//         const result: any = {};

//         Object.keys(subMenu).forEach((childKey) => {
//             const child = subMenu[childKey];
//             if (child.hide) return;

//             // If global access → allow all children
//             if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
//                 result[childKey] = {
//                     ...child,
//                     subMenu: child.subMenu ? filterSubMenu(child.subMenu) : undefined,
//                 };
//                 return;
//             }

//             // Normal permission checking
//             let r = getRight(child.id);
//             if (!r && child.parentModule) r = getRight(child.parentModule);
//             if (!r) return;

//             // LIST / DETAIL / VIEW → needs read
//             if (
//                 child.id.includes("list") ||
//                 child.id.includes("detail") ||
//                 child.id.includes("view")
//             ) {
//                 if (r.read) result[childKey] = child;
//                 return;
//             }

//             // CREATE
//             if (child.id.includes("create") && r.add) {
//                 result[childKey] = child;
//                 return;
//             }

//             // EDIT
//             if (child.id.includes("edit") && r.edit) {
//                 result[childKey] = child;
//                 return;
//             }

//             // Nested submenu
//             if (child.subMenu) {
//                 if (r.read) {
//                     const nestedFiltered = filterSubMenu(child.subMenu);
//                     result[childKey] = {
//                         ...child,
//                         subMenu: nestedFiltered,
//                     };
//                 }
//                 return;
//             }
//         });

//         return result;
//     };

//     Object.keys(menu).forEach((key) => {
//         const item = menu[key];
//         if (item.hide) return;

//         const parentRight = getRight(item.id);

//         // -----------------------------
//         // ✅ If global access → show entire tree
//         // -----------------------------
//         if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
//             filtered[key] = {
//                 ...item,
//                 subMenu: item.subMenu ? filterSubMenu(item.subMenu) : undefined,
//             };
//             return;
//         }

//         // -----------------------------
//         // NORMAL PERMISSION FLOW
//         // ------------------------------
//         let children = item.subMenu ? filterSubMenu(item.subMenu) : null;

//         // CASE 1: Parent has read OR children available
//         if (
//             (parentRight && parentRight.read) ||
//             (children && Object.keys(children).length > 0)
//         ) {
//             filtered[key] = {
//                 ...item,
//                 subMenu: children,
//             };
//         }
//     });

//     return filtered;
// };

// Hide menu
export const filterMenu = (menu: any, rights: any[], userRole: string) => {
	const filtered: any = {};

	// -----------------------------
	// ✅ GLOBAL RIGHTS (access_all)
	// -----------------------------
	const accessAll = rights.find((r) => r.name === 'access_all');

	const hasGlobalRead = accessAll?.read === true;
	const hasGlobalAdd = accessAll?.add === true;
	const hasGlobalEdit = accessAll?.edit === true;
	const hasGlobalDelete = accessAll?.delete === true;

	const getRight = (id: string) => rights.find((r) => r.name === id);

	const filterSubMenu = (subMenu: any) => {
		const result: any = {};

		Object.keys(subMenu).forEach((childKey) => {
			const child = subMenu[childKey];
			if (child.hide) return;

			// If global access → allow all children
			if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
				result[childKey] = {
					...child,
					subMenu: child.subMenu ? filterSubMenu(child.subMenu) : undefined,
				};
				return;
			}

			// Normal permission checking
			let r = getRight(child.id);
			if (!r && child.parentModule) r = getRight(child.parentModule);
			if (!r) return;

			// LIST / DETAIL / VIEW → needs read
			if (
				child.id.includes('list') ||
				child.id.includes('detail') ||
				child.id.includes('view')
			) {
				if (r.read) result[childKey] = child;
				return;
			}

			// CREATE
			if (child.id.includes('create') && r.add) {
				result[childKey] = child;
				return;
			}

			// EDIT
			if (child.id.includes('edit') && r.edit) {
				result[childKey] = child;
				return;
			}

			// Nested submenu
			if (child.subMenu) {
				if (r.read) {
					const nestedFiltered = filterSubMenu(child.subMenu);
					result[childKey] = {
						...child,
						subMenu: nestedFiltered,
					};
				}
				return;
			}
		});

		return result;
	};

	Object.keys(menu).forEach((key) => {
		const item = menu[key];

		if (item.hide) return;

		// Always hide "purchase_order" for Site officer
		if (userRole?.includes('Site officer') && item.id.includes('purchase_order')) return;
		// console.log(`userRole: "${userRole}", item.id: "${item.id}"`);

		const parentRight = getRight(item.id);

		// -----------------------------
		// ✅ If global access → show entire tree
		// -----------------------------
		if (hasGlobalRead || hasGlobalAdd || hasGlobalEdit || hasGlobalDelete) {
			filtered[key] = {
				...item,
				subMenu: item.subMenu ? filterSubMenu(item.subMenu) : undefined,
			};
			return;
		}

		// -----------------------------
		// NORMAL PERMISSION FLOW
		// -----------------------------
		let children = item.subMenu ? filterSubMenu(item.subMenu) : null;

		// CASE 1: Parent has read OR children available
		if ((parentRight && parentRight.read) || (children && Object.keys(children).length > 0)) {
			filtered[key] = {
				...item,
				subMenu: children,
			};
		}
	});

	return filtered;
};
